import React, { Component } from 'react';

class loader extends Component {
    render() {
        return (
            <div>
                <h1>Carregando...</h1>
            </div>
        );
    }
}

export default loader;


// WEBPACK FOOTER //
// ./src/components/aluno/loader/loader.js